<template>

	<a-card :bordered="false" class="dashboard-bar-line header-solid">
		<template #title>
			<h6>放行趋势</h6>
			<p>近 {{ days }} 日(截至昨日)放行量随时间的变化</p>
		</template>

		<!-- 加载中:别先显示"暂无记录"(看起来像没数据) -->
		<div v-if="loading" class="trend-empty"><a-spin /></div>

		<!-- 真有数据时画品牌蓝折线 -->
		<chart-line v-else-if="hasData" :height="310" :data="lineChartData"></chart-line>

		<!-- 确实无数据时的本地化业务空态（不用 ant 库存 SIMPLE 插画） -->
		<div v-else class="trend-empty">
			<div class="trend-empty__icon">
				<svg width="44" height="44" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6 38 L18 26 L26 32 L42 14" stroke="#1890ff" stroke-width="2.5"
						stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 5" opacity="0.55"/>
					<circle cx="42" cy="14" r="3" fill="#1890ff" opacity="0.55"/>
					<path d="M6 42 H44" stroke="#D6E4F0" stroke-width="2" stroke-linecap="round"/>
				</svg>
			</div>
			<p class="trend-empty__title">近 {{ days }} 日暂无放行记录</p>
			<p class="trend-empty__desc">斗篷放行真实访客后，这里会按日绘制放行量趋势</p>
		</div>

	</a-card>

</template>

<script>

	import ChartLine from '../Charts/ChartLine';
	import { getActiveAnalysis } from '@/api/index';

	export default ({
		components: {
			ChartLine,
		},
		props: {
			// 由 Dashboard 传入的近期拦截日志（每条含 time 字段），前端按日聚合，避免新增请求
			blockList: {
				type: Array,
				default: () => [],
			},
			// 聚合的天数窗口
			days: {
				type: Number,
				default: 7,
			},
		},
		data() {
			return {
				// 后端 /admin/activeanalysis 返回的近 7 日(截至昨日)每日放行/拦截量 [{date, pass, block}]
				trend: [],
				loading: true,
			};
		},
		mounted() {
			getActiveAnalysis().then((res) => {
				const t = res && res.data && res.data.trend;
				if (Array.isArray(t)) this.trend = t;
			}).catch(() => {}).finally(() => { this.loading = false; });
		},
		computed: {
			// 近 N 日按日的放行量:优先用后端按日统计好的 trend.pass,没有时回退到 blockList 前端聚合
			buckets() {
				if (this.trend.length) {
					return this.trend.map((t) => ({
						key: t.date,
						label: `${Number(t.date.slice(5, 7))}/${Number(t.date.slice(8, 10))}`,
						count: Number(t.pass) || 0,
					}));
				}
				const out = [];
				const today = new Date();
				today.setHours(0, 0, 0, 0);

				// 预建 N 个日期桶
				const index = {};
				for (let i = this.days - 1; i >= 0; i--) {
					const d = new Date(today);
					d.setDate(d.getDate() - i);
					const key = this.dateKey(d);
					const item = { key, label: `${d.getMonth() + 1}/${d.getDate()}`, count: 0 };
					index[key] = item;
					out.push(item);
				}

				// 把每条拦截日志按其 time 归入对应日期桶
				(this.blockList || []).forEach((row) => {
					if (!row || !row.time) return;
					const ts = new Date(String(row.time).replace(/-/g, '/'));
					if (isNaN(ts.getTime())) return;
					const key = this.dateKey(ts);
					if (index[key]) index[key].count += 1;
				});

				return out;
			},
			hasData() {
				return this.buckets.some((b) => b.count > 0);
			},
			lineChartData() {
				return {
					labels: this.buckets.map((b) => b.label),
					datasets: [{
						label: '放行量',
						tension: 0.4,
						pointRadius: 3,
						pointBackgroundColor: '#1890ff',
						borderColor: '#1890ff',
						borderWidth: 3,
						backgroundColor: 'rgba(24, 144, 255, 0.12)',
						fill: true,
						data: this.buckets.map((b) => b.count),
						maxBarThickness: 6,
					}],
				};
			},
		},
		methods: {
			dateKey(d) {
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				return `${y}-${m}-${day}`;
			},
		},
	})

</script>

<style lang="scss" scoped>
	.trend-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 310px;
		text-align: center;
		padding: 0 16px;

		&__icon {
			margin-bottom: 16px;
			opacity: 0.9;
		}

		&__title {
			margin: 0 0 6px;
			font-size: 15px;
			font-weight: 600;
			color: #3b4a66;
		}

		&__desc {
			margin: 0;
			font-size: 13px;
			color: #8c98ad;
			max-width: 320px;
		}
	}
</style>
